<template>
  <div>
    <h2 class="font_size_1000rem font_weight_bold mb-4">{{ titleText }}</h2>
    <div v-if="!questionnaires || questionnaires.length === 0">
      <p class="text-center pt-1 pb-4">
        {{ emptyListMessage }}
      </p>
    </div>
    <template v-else>
      <div class="shot_questionnaire_list" :class="{'load_more' : !isLoadMore}">
        <div
            v-for="questionnaire in visibleQuestionnaires"
            :key="questionnaire.id"
        >
          <questionnaire-short-item :questionnaire="questionnaire"/>
        </div>
      </div>
      <div class="d-flex justify-content-center">
        <b-button
            v-if="isLoadMore"
            variant="v3_teal_outline"
            class="mr-2 mb-2 mb-lg-0"
            @click="loadMore = true"
        >
          <span>Load More</span>
        </b-button>
      </div>
    </template>
  </div>
</template>

<script>
import QuestionnaireShortItem from '@/components/questionnaire/QuestionnaireShortItem';

export default {
  name: 'ShortQuestionnairesList',
  components: {
    QuestionnaireShortItem,
  },
  props: {
    questionnaires: {
      required: true,
      type: Array,
    },
    titleText: {
      required: true,
      type: String,
    },
    emptyListMessage: {
      required: true,
      type: String,
    },
  },
  data: function () {
    return {
      loadMore: false,
      defaultNumberOfVisibleQuestionnaires: 5,
    };
  },
  computed: {
    visibleQuestionnaires: function () {
      return this.loadMore
          ? this.questionnaires
          : this.questionnaires.slice(
              0,
              this.defaultNumberOfVisibleQuestionnaires
          );
    },
    isLoadMore: function () {
      return this.questionnaires.length >= this.defaultNumberOfVisibleQuestionnaires && !this.loadMore;
    }
  },
  methods: {},
};
</script>

<style lang="scss">
@import '../../../../sass/v3.scss';

.shot_questionnaire_list {
  position: relative;

  &:after {
    content: '';
    position: absolute;
    top: 0;
    bottom: 0;
    left: -15px;
    right: -15px;
    box-shadow: inset white 0 -150px 150px;
  }

  &.load_more {
    &:after {
      content: none;
    }
  }
}
</style>
